import { ADD_BANK, ADD_BANKS, SET_BANK_FILTERS, ARCHIVE_BANK, ASSOCIATE_ENTRIES, DISASSOCIATE_ENTRY, REMOVE_BANK } from '@instructure/quiz-common';
export var addBank = function addBank(bankId, selectedBank) {
  return {
    type: ADD_BANK,
    payload: {
      id: bankId,
      bank: selectedBank
    }
  };
};
export var addBanks = function addBanks(banks) {
  return {
    type: ADD_BANKS,
    payload: banks
  };
};
export var setBankFilters = function setBankFilters(bankId, filters) {
  return {
    type: SET_BANK_FILTERS,
    payload: {
      bankId: bankId,
      filters: filters
    }
  };
};
export var associateEntries = function associateEntries(bankId, bankEntryIds) {
  return {
    type: ASSOCIATE_ENTRIES,
    payload: {
      bankId: bankId,
      bankEntryIds: bankEntryIds
    }
  };
};
export var disassociateEntry = function disassociateEntry(bankId, bankEntryId) {
  return {
    type: DISASSOCIATE_ENTRY,
    payload: {
      bankId: bankId,
      bankEntryId: bankEntryId
    }
  };
};
export var removeBank = function removeBank(bankId) {
  return {
    type: REMOVE_BANK,
    payload: bankId
  };
};
export var archiveBank = function archiveBank(bankId) {
  return {
    type: ARCHIVE_BANK,
    payload: bankId
  };
};